import React, { FC } from 'react'
import { get } from 'lodash'
import cx from 'classnames'
import { Button, ButtonProps, Classes, Intent } from '@blueprintjs/core'
import { Icon } from '..'
import css from './button.module.scss'

export interface IUIButtonProps extends ButtonProps {
  autoFocus?: boolean
  hasError?: string
  blue?: boolean
  round?: boolean
  ghost?: boolean
  iconName?: string
  rightIconName?: string
  style?: any
  onBlur?: () => void
  'data-button'?: string
}

const ButtonWithFAIcons: FC<React.PropsWithChildren<IUIButtonProps>> = ({
  hasError,
  blue,
  round,
  minimal,
  ghost = !minimal,
  iconName,
  rightIconName,
  ...props
}) => {
  let iconEl = null
  let rightIconEl = null
  let className = get(props, 'className', '')
  if (blue) {
    className += ' blue'
  }
  if (round) {
    className += ' round'
  }

  if (hasError) {
    className += 'has-error'
  }

  if (iconName) {
    const iconProps = {
      style: { marginRight: 8 },
    }

    iconEl = <Icon name={iconName} {...iconProps} />
  }

  if (rightIconName) {
    rightIconEl = <Icon name={rightIconName} style={{ marginTop: 2 }} />
  }

  return (
    <Button
      {...props}
      minimal={minimal && props.intent !== Intent.PRIMARY}
      className={className}
      icon={iconEl}
      rightIcon={props.rightIcon || rightIconEl}
    />
  )
}

export const ShadowButtonStyled: FC<React.PropsWithChildren<IUIButtonProps>> = ({
  className = '',
  ...props
}) => <ButtonWithFAIcons className={cx(css.fa_icons_button_shadow, className)} {...props} />

export default ButtonWithFAIcons
